module.exports = __webpack_public_path__ + "img/exhibits-background.7b29a5b9.png";